import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../routers/AppRouter';
import { createMicrosite, getMicrosite, updateMicrosite } from '../../../actions/microsite';
import Spinner from "../../../components/Spinner";

import Dropzone from 'react-dropzone';
import {
  base64StringtoFile,
  downloadBase64File,
  extractImageFileExtensionFromBase64,
  image64toCanvasRef
} from '../../../utility/reusable-utils';

import styled from 'styled-components';
import { FormContainer, FormFieldRow, FormFieldColumn, FormSection, FormField, FormInputFull, FormInput, FormTextArea, FormLabel, FormSubHeading, FormItalicHeading, FormSectionPadding, FormFileName, FormInputCharCount } from '../../../styles/form-styles.js';
import colors from '../../../styles/colors';
import ABButton from '../../../components/ABButton';
import ABSmallButton from '../../../components/ABSmallButton';
import { saveSingleFile } from '../../../actions/upload';
import { updateMicrositeSubmission } from '../../../actions/microsite-submission';
import { setLocation } from '../../../actions/location';
import { shortenFileName } from '../../../utility/string-utils';
import { getMicrositeSetting, updateMicrositeSetting } from '../../../actions/microsite-settings';

const PageWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const PageHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
`;

const PageTitle = styled.div`
  color: ${colors.blue};
  font-size: 30px;
  padding: 30px 0;
`;

const SkipSection = styled.form`
  font-size: 15px;
  display: flex;
  align-items: center;
  input {
    margin-right: 5px;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
  div:first-child {
    padding-right: 10px;
  }
`;

const RightButton = styled.div`
  display: flex;
  justify-content: space-around;
`;

const ProductContainer = styled.div`
  padding: 10px 0;
`;

const ImagePreview = styled.img`
  max-width: 300px;
  max-height: 150px;
  object-fit: cover;
  margin-left: 20px;
`;

const CenterImage = styled.div`
  padding: 0 0 15px 0;
`;

const ImageSelection = styled.div`
  display: flex;
  // max-width: 300px;
  max-height: 150px;
  border: none;
  font-weight: bold;
  font-size: 18px;
  color: #1194F6;
  cursor: pointer;
  outline: none;
`;

const UploadButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ValidationError = styled.div`
  color: red;
  padding-left: 10px;
  font-weight: normal;
  font-size: 15px;
`;

const UploadSpinner = styled.div`
  font-size: 14px;
  padding: 20px 0;
  max-width: 1365px;
  text-align: center;
`;

const imageMaxSize = 1000000000; // bytes
const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif';
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => { return item.trim() });

class Panels extends Component {

  constructor(props) {
    super(props);

    this.state = {
      addProductName: '',
      addProductButtonText: '',
      addProductButtonLink: '',
      addProductName2: '',
      addProductButtonText2: '',
      addProductButtonLink2: '',
      addProductName3: '',
      addProductButtonText3: '',
      addProductButtonLink3: '',
      addProductName4: '',
      addProductButtonText4: '',
      addProductButtonLink4: '',
      imgSrc: null,
      imgSrc2: null,
      imgSrc3: null,
      imgSrc4: null,
      imgSrcExt: null,
      uploadedFile: null,
      uploadedFileName: '',
      imageUploading: false,
      uploadedFile2: null,
      uploadedFileName2: '',
      uploadedFile3: null,
      uploadedFileName3: '',
      uploadedFile4: null,
      uploadedFileName4: '',
      showSection: false,
      imageSizeError1: false,
      imageSizeError2: false,
      imageSizeError3: false,
      imageSizeError4: false,
    };

  }

  componentDidMount = () => {
    if (this.props.match.params.id) {
      this.props.getMicrosite(this.props.match.params.id);
      this.props.getMicrositeSetting(this.props.match.params.id);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.microsite !== prevProps.microsite) {
      this.loadFields();
    }
    if (this.props.micrositeSetting !== prevProps.micrositeSetting) {
      this.setState({
        showSection: this.props.micrositeSetting.showAddProducts || false
      });
    }
  }

  loadFields = () => {

    this.setState({
      addProductName: this.props.microsite.addProductName,
      addProductButtonText: this.props.microsite.addProductButtonText,
      addProductButtonLink: this.props.microsite.addProductButtonLink,

      addProductName2: this.props.microsite.addProductName2,
      addProductButtonText2: this.props.microsite.addProductButtonText2,
      addProductButtonLink2: this.props.microsite.addProductButtonLink2,

      addProductName3: this.props.microsite.addProductName3,
      addProductButtonText3: this.props.microsite.addProductButtonText3,
      addProductButtonLink3: this.props.microsite.addProductButtonLink3,

      addProductName4: this.props.microsite.addProductName4,
      addProductButtonText4: this.props.microsite.addProductButtonText4,
      addProductButtonLink4: this.props.microsite.addProductButtonLink4,

      uploadedFileName: this.props.microsite.addProductImage || '',
      uploadedFileName2: this.props.microsite.addProductImage2 || '',
      uploadedFileName3: this.props.microsite.addProductImage3 || '',
      uploadedFileName4: this.props.microsite.addProductImage4 || ''
    });
  };

  onNextClick = (close) => {

    if (!this.state.imageSizeError1 && !this.state.imageSizeError2 && !this.state.imageSizeError3 && !this.state.imageSizeError4) {
      this.props.setLocation('featured-resources');

      if (this.state.uploadedFile || this.state.uploadedFile2 || this.state.uploadedFile3 || this.state.uploadedFile4) {
        this.setState({ imageUploading: true });

        let formattedCompanyName = this.props.microsite.company.split(' ').join('-').toLowerCase();

        // only add the ones they added and use the fileNumber to keep where they go in the db
        let allCloudFrontUrls = [];
        let allUploadedFiles = [];

        if (this.state.uploadedFile) {
          allUploadedFiles.push({ fileNumber: 1, file: this.state.uploadedFile });
        }

        if (this.state.uploadedFile2) {
          allUploadedFiles.push({ fileNumber: 2, file: this.state.uploadedFile2 });
        }

        if (this.state.uploadedFile3) {
          allUploadedFiles.push({ fileNumber: 3, file: this.state.uploadedFile3 });
        }

        if (this.state.uploadedFile4) {
          allUploadedFiles.push({ fileNumber: 4, file: this.state.uploadedFile4 });
        }

        let count = 0;
        allUploadedFiles.map((item, index) => {
          this.props.saveSingleFile(item.file, formattedCompanyName, 'microsites')
            .then((cloudFrontUrl) => {
              allCloudFrontUrls.push({ fileNumber: item.fileNumber, cloudFrontUrl: cloudFrontUrl });
              console.log('cloudfront url returned: ', cloudFrontUrl);
              count++;
              if (count === allUploadedFiles.length) {
                console.log('saving with: ', allCloudFrontUrls);
                this.setState({ imageUploading: false });
                this.saveForm(allCloudFrontUrls, close);
              }
            });
        });
      } else {
        this.saveForm(null, close);
      }
    }

  };

  saveForm = (allCloudFrontUrls, close) => {

    let micrositeSetting = {
      showAddProducts: this.state.showSection
    };

    let microsite = {
      addProductName: this.state.addProductName,
      addProductButtonText: this.state.addProductButtonText,
      addProductButtonLink: this.state.addProductButtonLink,
      addProductName2: this.state.addProductName2,
      addProductButtonText2: this.state.addProductButtonText2,
      addProductButtonLink2: this.state.addProductButtonLink2,
      addProductName3: this.state.addProductName3,
      addProductButtonText3: this.state.addProductButtonText3,
      addProductButtonLink3: this.state.addProductButtonLink3,
      addProductName4: this.state.addProductName4,
      addProductButtonText4: this.state.addProductButtonText4,
      addProductButtonLink4: this.state.addProductButtonLink4,
      userId: this.props.microsite.userId
    };

    // need to make sure we add the correct image ur to the correct name in the database
    if (allCloudFrontUrls) {
      allCloudFrontUrls.map((item, index) => {
        switch (item.fileNumber) {
          case 1:
            console.log('image 1');
            microsite.addProductImage = item.cloudFrontUrl;
            break;
          case 2:
            console.log('image 2');
            microsite.addProductImage2 = item.cloudFrontUrl;
            break;
          case 3:
            console.log('image 3');
            microsite.addProductImage3 = item.cloudFrontUrl;
            break;
          case 4:
            console.log('image 4');
            microsite.addProductImage4 = item.cloudFrontUrl;
            break;
          default:
          // should only be 4 max
        }
      });
    }

    this.props.updateMicrosite(microsite, this.props.microsite.id);

    let micrositeSubmission = {
      addProducts: true
    };
    this.props.updateMicrositeSubmission(micrositeSubmission, this.props.microsite.id);

    this.props.updateMicrositeSetting(micrositeSetting, this.props.microsite.id);

    if (close) {
      history.push(`../${this.props.microsite.id}`);
      return;
    }
  };

  onAddProductNameChange = (e) => {
    const addProductName = e.target.value;
    if (addProductName.length <= 50) {
      this.setState(() => ({ addProductName }));
    }
  };

  onAddProductButtonTextChange = (e) => {
    const addProductButtonText = e.target.value;
    if (addProductButtonText.length <= 25) {
      this.setState(() => ({ addProductButtonText }));
    }
  };

  onAddProductButtonLinkChange = (e) => {
    const addProductButtonLink = e.target.value;
    this.setState(() => ({ addProductButtonLink }));
  };

  onAddProductNameChange2 = (e) => {
    const addProductName2 = e.target.value;
    if (addProductName2.length <= 50) {
      this.setState(() => ({ addProductName2 }));
    }
  };

  onAddProductButtonTextChange2 = (e) => {
    const addProductButtonText2 = e.target.value;
    if (addProductButtonText2.length <= 25) {
      this.setState(() => ({ addProductButtonText2 }));
    }
  };

  onAddProductButtonLinkChange2 = (e) => {
    const addProductButtonLink2 = e.target.value;
    this.setState(() => ({ addProductButtonLink2 }));
  };

  onAddProductNameChange3 = (e) => {
    const addProductName3 = e.target.value;
    if (addProductName3.length <= 50) {
      this.setState(() => ({ addProductName3 }));
    }
  };

  onAddProductButtonTextChange3 = (e) => {
    const addProductButtonText3 = e.target.value;
    if (addProductButtonText3.length <= 25) {
      this.setState(() => ({ addProductButtonText3 }));
    }
  };

  onAddProductButtonLinkChange3 = (e) => {
    const addProductButtonLink3 = e.target.value;
    this.setState(() => ({ addProductButtonLink3 }));
  };

  onAddProductNameChange4 = (e) => {
    const addProductName4 = e.target.value;
    if (addProductName4.length <= 50) {
      this.setState(() => ({ addProductName4 }));
    }
  };

  onAddProductButtonTextChange4 = (e) => {
    const addProductButtonText4 = e.target.value;
    if (addProductButtonText4.length <= 25) {
      this.setState(() => ({ addProductButtonText4 }));
    }
  };

  onAddProductButtonLinkChange4 = (e) => {
    const addProductButtonLink4 = e.target.value;
    this.setState(() => ({ addProductButtonLink4 }));
  };

  toggleCheckbox = (e) => {
    const showSection = e.target.checked;
    this.setState(() => ({ showSection: !showSection }));
  };

  // File upload

  verifyFile = (files) => {
    if (files && files.length > 0) {
      const currentFile = files[0];
      const currentFileType = currentFile.type;
      const currentFileSize = currentFile.size;
      if (currentFileSize > imageMaxSize) {
        alert(`This file is not allowed. ${currentFileSize} bytes is too large`);
        return false
      }
      if (!acceptedFileTypesArray.includes(currentFileType)) {
        console.log('file type not allowed!');
        alert('This file is not allowed. Only images are allowed.');
        return false
      }
      return true
    }
  };

  handleOnDrop(files, rejectedFiles, fileNumber) {

    if (rejectedFiles && rejectedFiles.length > 0) {
      this.verifyFile(rejectedFiles)
    }

    if (files && files.length > 0) {
      const isVerified = this.verifyFile(files);
      if (isVerified) {
        // imageBase64Data
        const currentFile = files[0];
        const myFileItemReader = new FileReader();
        myFileItemReader.addEventListener("load", () => {
          // console.log(myFileItemReader.result)
          const myResult = myFileItemReader.result;
          this.isValidImageSize(myResult, 239, 325, fileNumber);
          if (fileNumber === 2) {
            this.setState({
              imgSrc2: myResult,
              uploadedFile2: currentFile,
              uploadedFileName2: files[0].name
            })
          } else if (fileNumber === 3) {
            this.setState({
              imgSrc3: myResult,
              uploadedFile3: currentFile,
              uploadedFileName3: files[0].name
            })
          } else if (fileNumber === 4) {
            this.setState({
              imgSrc4: myResult,
              uploadedFile4: currentFile,
              uploadedFileName4: files[0].name
            })
          } else {
            this.setState({
              imgSrc: myResult, //this is the base64 code for preview
              imgSrcExt: extractImageFileExtensionFromBase64(myResult),
              uploadedFile: currentFile,
              uploadedFileName: files[0].name
            })
          }
        }, false);

        myFileItemReader.readAsDataURL(currentFile)

      }
    }

  }

  imageCheck() {
    if (this.state.imgSrc != null) {
      return <FormFileName>{this.state.uploadedFileName}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName)}</FormFileName> // puilled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck2() {
    if (this.state.imgSrc2 != null) {
      return <FormFileName>{this.state.uploadedFileName2}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName2 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName2)}</FormFileName> // puilled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck3() {
    if (this.state.imgSrc3 != null) {
      return <FormFileName>{this.state.uploadedFileName3}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName3 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName3)}</FormFileName> // puilled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  imageCheck4() {
    if (this.state.imgSrc4 != null) {
      return <FormFileName>{this.state.uploadedFileName4}</FormFileName> // just uploaded
    } else if (this.state.uploadedFileName4 !== null) {
      // return <ImagePreview src={this.state.imgSrc} />
      return <FormFileName>{shortenFileName(this.state.uploadedFileName4)}</FormFileName> // puilled from server
    } else {
      return (
        <div></div>
      )
    }
  }

  isValidImageSize = (fileDetails, width, height, fileNumber) => {
    let globalThis = this;
    let image = new Image();
    image.src = fileDetails;
    image.onload = function () {
      if (this.width === width && this.height === height) {
        globalThis.setSingleImageError(false, fileNumber);
      } else {
        globalThis.setSingleImageError(true, fileNumber);
      }
    };
  };

  setSingleImageError = (showError, fileNumber) => {
    if (fileNumber === 1) {
      this.setState({
        imageSizeError1: showError
      });
    } else if (fileNumber === 2) {
      this.setState({
        imageSizeError2: showError
      });
    } else if (fileNumber === 3) {
      this.setState({
        imageSizeError3: showError
      });
    } else if (fileNumber === 4) {
      this.setState({
        imageSizeError4: showError
      });
    }
  };

  render() {
    return (
      <>
        <PageWrapper>
          <PageHeading>
            <PageTitle>Panels</PageTitle>
            <SkipSection>
              <input
                type='checkbox'
                checked={!this.state.showSection}
                onChange={(e) => this.toggleCheckbox(e)}
              />
              Disable this section
            </SkipSection>
          </PageHeading>
          <FormContainer>
            <FormSection>

              <ProductContainer>
                <FormSubHeading>Additional Product/Service 1:</FormSubHeading>
                <FormLabel>Name</FormLabel>
                <FormItalicHeading>Product/Service Name should not exceed 50 characters including spaces.</FormItalicHeading>
                <div>
                  <FormField>
                    <FormInputFull
                      value={this.state.addProductName}
                      onChange={this.onAddProductNameChange}
                      type="text"
                      tabIndex="1"
                    />
                  </FormField>
                  {
                    this.state.addProductName &&
                    <FormInputCharCount>Char count: {this.state.addProductName.length}</FormInputCharCount>
                  }
                </div>

                <FormSectionPadding>
                  <FormLabel>Button Text</FormLabel>
                  <FormItalicHeading>Not to exceed 25 characters including spaces.</FormItalicHeading>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonText}
                        onChange={this.onAddProductButtonTextChange}
                        type="text"
                        tabIndex="2"
                      />
                      {
                        this.state.addProductButtonText &&
                        <FormInputCharCount>Char count: {this.state.addProductButtonText.length}</FormInputCharCount>
                      }
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Link URL</FormLabel>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonLink}
                        onChange={this.onAddProductButtonLinkChange}
                        type="text"
                        tabIndex="3"
                      />
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Product/Service Image</FormLabel>
                  <FormItalicHeading>The submitted Product/Service Image should be exactly 239 pixels wide and 325 pixels tall.</FormItalicHeading>
                  <div>
                    <FormField>
                      <CenterImage>
                        <Dropzone
                          onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 1)}
                          multiple={false}
                          accept={acceptedFileTypes}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section tabIndex="4">
                              <ImageSelection {...getRootProps()}>
                                <input {...getInputProps()} />
                                <ABSmallButton title="File Upload" />
                                <UploadButtonContainer>
                                  {this.imageCheck()}
                                  {
                                    this.state.imageSizeError1 &&
                                    <ValidationError>Invalid Image Size</ValidationError>
                                  }
                                </UploadButtonContainer>
                              </ImageSelection>
                              {
                                this.state.uploadedFileName !== '' &&
                                <button onClick={() => this.setState({ uploadedFileName: null })}>Remove X</button>
                              }
                            </section>
                          )}
                        </Dropzone>
                      </CenterImage>
                    </FormField>
                  </div>
                </FormSectionPadding>
              </ProductContainer>

              <ProductContainer>
                <FormSubHeading>Additional Product/Service 3:</FormSubHeading>
                <FormLabel>Name</FormLabel>
                <FormItalicHeading>Product/Service Name should not exceed 50 characters including spaces.</FormItalicHeading>
                <div>
                  <FormField>
                    <FormInputFull
                      value={this.state.addProductName3}
                      onChange={this.onAddProductNameChange3}
                      type="text"
                      tabIndex="9"
                    />
                    {
                      this.state.addProductName3 &&
                      <FormInputCharCount>Char count: {this.state.addProductName3.length}</FormInputCharCount>
                    }
                  </FormField>
                </div>

                <FormSectionPadding>
                  <FormLabel>Button Text</FormLabel>
                  <FormItalicHeading>Not to exceed 25 characters including spaces.</FormItalicHeading>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonText3}
                        onChange={this.onAddProductButtonTextChange3}
                        type="text"
                        tabIndex="10"
                      />
                      {
                        this.state.addProductButtonText3 &&
                        <FormInputCharCount>Char count: {this.state.addProductButtonText3.length}</FormInputCharCount>
                      }
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Link URL</FormLabel>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonLink3}
                        onChange={this.onAddProductButtonLinkChange3}
                        type="text"
                        tabIndex="11"
                      />
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Product/Service Image</FormLabel>
                  <FormItalicHeading>The submitted Product/Service Image should be exactly 239 pixels wide and 325 pixels tall.</FormItalicHeading>
                  <div>
                    <FormField>
                      <CenterImage>
                        <Dropzone
                          onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 3)}
                          multiple={false}
                          accept={acceptedFileTypes}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section tabIndex="12">
                              <ImageSelection {...getRootProps()}>
                                <input {...getInputProps()} />
                                <ABSmallButton title="File Upload" />
                                <UploadButtonContainer>
                                  {this.imageCheck3()}
                                  {
                                    this.state.imageSizeError3 &&
                                    <ValidationError>Invalid Image Size</ValidationError>
                                  }
                                </UploadButtonContainer>
                              </ImageSelection>
                              {
                                this.state.uploadedFileName3 !== '' &&
                                <button onClick={() => this.setState({ uploadedFileName3: null })}>Remove X</button>
                              }
                            </section>
                          )}
                        </Dropzone>
                      </CenterImage>
                    </FormField>
                  </div>
                </FormSectionPadding>
              </ProductContainer>

            </FormSection>

            <FormSection>

              <ProductContainer>
                <FormSubHeading>Additional Product/Service 2:</FormSubHeading>
                <FormLabel>Name</FormLabel>
                <FormItalicHeading>Product/Service Name should not exceed 50 characters including spaces.</FormItalicHeading>
                <div>
                  <FormField>
                    <FormInputFull
                      value={this.state.addProductName2}
                      onChange={this.onAddProductNameChange2}
                      type="text"
                      tabIndex="5"
                    />
                    {
                      this.state.addProductName2 &&
                      <FormInputCharCount>Char count: {this.state.addProductName2.length}</FormInputCharCount>
                    }
                  </FormField>
                </div>

                <FormSectionPadding>
                  <FormLabel>Button Text</FormLabel>
                  <FormItalicHeading>Not to exceed 25 characters including spaces.</FormItalicHeading>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonText2}
                        onChange={this.onAddProductButtonTextChange2}
                        type="text"
                        tabIndex="6"
                      />
                      {
                        this.state.addProductButtonText2 &&
                        <FormInputCharCount>Char count: {this.state.addProductButtonText2.length}</FormInputCharCount>
                      }
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Link URL</FormLabel>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonLink2}
                        onChange={this.onAddProductButtonLinkChange2}
                        type="text"
                        tabIndex="7"
                      />
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Product/Service Image</FormLabel>
                  <FormItalicHeading>The submitted Product/Service Image should be exactly 239 pixels wide and 325 pixels tall.</FormItalicHeading>
                  <div>
                    <FormField>
                      <CenterImage>
                        <Dropzone
                          onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 2)}
                          multiple={false}
                          accept={acceptedFileTypes}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section tabIndex="8">
                              <ImageSelection {...getRootProps()}>
                                <input {...getInputProps()} />
                                <ABSmallButton title="File Upload" />
                                <UploadButtonContainer>
                                  {this.imageCheck2()}
                                  {
                                    this.state.imageSizeError2 &&
                                    <ValidationError>Invalid Image Size</ValidationError>
                                  }
                                </UploadButtonContainer>
                              </ImageSelection>
                              {
                                this.state.uploadedFileName2 !== '' &&
                                <button onClick={() => this.setState({ uploadedFileName2: null })}>Remove X</button>
                              }
                            </section>
                          )}
                        </Dropzone>
                      </CenterImage>
                    </FormField>
                  </div>
                </FormSectionPadding>
              </ProductContainer>

              <ProductContainer>
                <FormSubHeading>Additional Product/Service 4:</FormSubHeading>
                <FormLabel>Name</FormLabel>
                <FormItalicHeading>Product/Service Name should not exceed 50 characters including spaces.</FormItalicHeading>
                <div>
                  <FormField>
                    <FormInputFull
                      value={this.state.addProductName4}
                      onChange={this.onAddProductNameChange4}
                      type="text"
                      tabIndex="13"
                    />
                    {
                      this.state.addProductName4 &&
                      <FormInputCharCount>Char count: {this.state.addProductName4.length}</FormInputCharCount>
                    }
                  </FormField>
                </div>

                <FormSectionPadding>
                  <FormLabel>Button Text</FormLabel>
                  <FormItalicHeading>Not to exceed 25 characters including spaces.</FormItalicHeading>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonText4}
                        onChange={this.onAddProductButtonTextChange4}
                        type="text"
                        tabIndex="14"
                      />
                      {
                        this.state.addProductButtonText4 &&
                        <FormInputCharCount>Char count: {this.state.addProductButtonText4.length}</FormInputCharCount>
                      }
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Link URL</FormLabel>
                  <div>
                    <FormField>
                      <FormInputFull
                        value={this.state.addProductButtonLink4}
                        onChange={this.onAddProductButtonLinkChange4}
                        type="text"
                        tabIndex="15"
                      />
                    </FormField>
                  </div>
                </FormSectionPadding>

                <FormSectionPadding>
                  <FormLabel>Product/Service Image</FormLabel>
                  <FormItalicHeading>The submitted Product/Service Image should be exactly 239 pixels wide and 325 pixels tall.</FormItalicHeading>
                  <div>
                    <FormField>
                      <CenterImage>
                        <Dropzone
                          onDrop={(acceptedFiles) => this.handleOnDrop(acceptedFiles, null, 4)}
                          multiple={false}
                          accept={acceptedFileTypes}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section tabIndex="16">
                              <ImageSelection {...getRootProps()}>
                                <input {...getInputProps()} />
                                <ABSmallButton title="File Upload" />
                                <UploadButtonContainer>
                                  {this.imageCheck4()}
                                  {
                                    this.state.imageSizeError4 &&
                                    <ValidationError>Invalid Image Size</ValidationError>
                                  }
                                </UploadButtonContainer>
                              </ImageSelection>
                              {
                                this.state.uploadedFileName4 !== '' &&
                                <button onClick={() => this.setState({ uploadedFileName4: null })}>Remove X</button>
                              }
                            </section>
                          )}
                        </Dropzone>
                      </CenterImage>
                    </FormField>
                  </div>
                </FormSectionPadding>
              </ProductContainer>

            </FormSection>

          </FormContainer>

          <ActionButtons tabIndex="17">
            <div></div>
            <RightButton>
              <ABButton title="Save & Close" onClick={() => this.onNextClick(true)} />
            </RightButton>
          </ActionButtons>
          {
            (this.state.imageUploading) &&
            <UploadSpinner>
              <Spinner />
              <div>Please wait, this could take a few minutes. Please allow for additional time if your submission includes video files.</div>
            </UploadSpinner>
          }

        </PageWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.accountInfo.loading,
    error: state.accountInfo.error,
    errorMessage: state.accountInfo.errorMessage,
    microsite: state.microsite.data,
    micrositeSetting: state.micrositeSetting.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMicrosite: (id) => dispatch(getMicrosite(id)),
  getMicrositeSetting: (id) => dispatch(getMicrositeSetting(id)),
  updateMicrosite: (microsite, micrositeId) => dispatch(updateMicrosite(microsite, micrositeId)),
  updateMicrositeSubmission: (micrositeSubmission, micrositeId) => dispatch(updateMicrositeSubmission(micrositeSubmission, micrositeId)),
  saveSingleFile: (file, subFolder, mainFolder) => dispatch(saveSingleFile(file, subFolder, mainFolder)),
  setLocation: (page) => dispatch(setLocation(page)),
  updateMicrositeSetting: (micrositeSetting, micrositeId) => dispatch(updateMicrositeSetting(micrositeSetting, micrositeId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Panels);
